var exports = {
  "k": "xcc377c0b--f0713b--container",
};

module.exports = exports;
